import { createWebHistory, createRouter } from "vue-router";
import Login from "@/views/LoginView.vue";
import NotFound from "@/views/NotFoundView.vue";
import Panel from "@/views/PanelView.vue";

const routes = [
  {
    path: "/",
    name: "panel",
    component: Panel,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
